"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withField = exports.mapFieldContextToProps = exports.mapFormContextToProps = exports.WithFieldWrapper = void 0;

var react_1 = __importDefault(require("react"));

var fieldContext_1 = require("../channels/fieldContext");

var formContext_1 = require("../channels/formContext");

var Field_1 = __importDefault(require("../Form/Field"));

var decorators_1 = require("./decorators");

exports.WithFieldWrapper = function (props) {
  var insideForm = props.insideForm,
      insideField = props.insideField,
      children = props.children;

  if (!insideForm || insideField) {
    return react_1.default.Children.only(children);
  }

  return react_1.default.createElement(Field_1.default, __assign({}, props), children);
};

function mapFormContextToProps(_a) {
  var insideForm = _a.insideForm;
  return {
    insideForm: insideForm
  };
}

exports.mapFormContextToProps = mapFormContextToProps;

function mapFieldContextToProps(_a) {
  var insideField = _a.insideField;
  return {
    insideField: insideField
  };
}

exports.mapFieldContextToProps = mapFieldContextToProps;
var Wrapper = decorators_1.combineDecorators(formContext_1.withFormContext(mapFormContextToProps), fieldContext_1.withFieldContext(mapFieldContextToProps))(exports.WithFieldWrapper);
exports.withField = decorators_1.createWrapDecorator(Wrapper);